package org.nfeliciano.pages

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.stevdza.san.components.BackToTopButton
import com.stevdza.san.components.OverflowMenu
import com.stevdza.san.sections.AboutSection
import com.stevdza.san.sections.ContactSection
import com.stevdza.san.sections.FooterSection
import com.stevdza.san.sections.MainSection
import com.stevdza.san.sections.LikesSection
import com.stevdza.san.sections.PortfolioSection
import com.varabyte.kobweb.compose.css.StyleVariable
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.add
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.base
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.vh
import org.jetbrains.compose.web.dom.Div
import org.nfeliciano.components.layouts.PageLayoutData

// Container that has a tagline and grid on desktop, and just the tagline on mobile
val HeroContainerStyle = CssStyle {
    base { Modifier.fillMaxWidth().gap(2.cssRem) }
    Breakpoint.MD { Modifier.margin { top(20.vh) } }
}

// A demo grid that appears on the homepage because it looks good
val HomeGridStyle = CssStyle.base {
    Modifier
        .gap(0.5.cssRem)
        .width(70.cssRem)
        .height(18.cssRem)
}

private val GridCellColorVar by StyleVariable<Color>()
val HomeGridCellStyle = CssStyle.base {
    Modifier
        .backgroundColor(GridCellColorVar.value())
        .boxShadow(blurRadius = 0.6.cssRem, color = GridCellColorVar.value())
        .borderRadius(1.cssRem)
}

@Composable
private fun GridCell(color: Color, row: Int, column: Int, width: Int? = null, height: Int? = null) {
    Div(
        HomeGridCellStyle.toModifier()
            .setVariable(GridCellColorVar, color)
            .gridItem(row, column, width, height)
            .toAttrs()
    )
}


@InitRoute
fun initHomePage(ctx: InitRouteContext) {
    ctx.data.add(PageLayoutData("Home"))
}

// Explicitly map this page to "/"
@Page(routeOverride = "/")
//@Layout(".components.layouts.PageLayout")
@Composable
fun Index() {
    var menuOpened by remember { mutableStateOf(false) }
    Box(modifier = Modifier.fillMaxSize()) {
        Column(
            modifier = Modifier.fillMaxSize(),
            verticalArrangement = Arrangement.Top,
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            MainSection(onMenuClicked = { menuOpened = true })
            AboutSection()
            PortfolioSection()
            LikesSection()
//            AchievementsSection()
//            TestimonialSection()
//            ExperienceSection()
            ContactSection()
            FooterSection()
        }
        BackToTopButton()
        if (menuOpened) {
            OverflowMenu(onMenuClosed = { menuOpened = false })
        }
    }
}

//@Page
//@Layout(".components.layouts.PageLayout")
//@Composable
//fun HomePage() {
//    Row(HeroContainerStyle.toModifier()) {
//        Box {
//            val sitePalette = ColorMode.current.toSitePalette()
//
//            Column(Modifier.gap(2.cssRem)) {
//                Div(HeadlineTextStyle.toAttrs()) {
//                    SpanText(
//                        "Use this template as your starting point for ", Modifier.color(
//                            when (ColorMode.current) {
//                                ColorMode.LIGHT -> Colors.Black
//                                ColorMode.DARK -> Colors.White
//                            }
//                        )
//                    )
//                    SpanText(
//                        "Kobweb",
//                        Modifier
//                            .color(sitePalette.brand.accent)
//                            // Use a shadow so this light-colored word is more visible in light mode
//                            .textShadow(0.px, 0.px, blurRadius = 0.5.cssRem, color = Colors.Gray)
//                    )
//                }
//
//                Div(SubheadlineTextStyle.toAttrs()) {
//                    SpanText("You can read the ")
//                    Link("/about", "About")
//                    SpanText(" page for more information.")
//                }
//
//                val ctx = rememberPageContext()
//                Button(onClick = {
//                    // Change this click handler with your call-to-action behavior
//                    // here. Link to an order page? Open a calendar UI? Play a movie?
//                    // Up to you!
//                    ctx.router.tryRoutingTo("/about")
//                }, colorPalette = ColorPalettes.Blue) {
//                    Text("This could be your CTA")
//                }
//            }
//        }
//
//        Div(
//            HomeGridStyle
//            .toModifier()
//            .displayIfAtLeast(Breakpoint.MD)
//            .grid {
//                rows { repeat(3) { size(1.fr) } }
//                columns { repeat(5) { size(1.fr) } }
//            }
//            .toAttrs()
//        ) {
//            val sitePalette = ColorMode.current.toSitePalette()
//            GridCell(sitePalette.brand.primary, 1, 1, 2, 2)
//            GridCell(ColorPalettes.Monochrome._600, 1, 3)
//            GridCell(ColorPalettes.Monochrome._100, 1, 4, width = 2)
//            GridCell(sitePalette.brand.accent, 2, 3, width = 2)
//            GridCell(ColorPalettes.Monochrome._300, 2, 5)
//            GridCell(ColorPalettes.Monochrome._800, 3, 1, width = 5)
//        }
//    }
//}
